import React, { FunctionComponent, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getGranules } from '../../services/GranuleService';
import { Granule } from '../../types/Granule';
import { GranulesSummary } from '../granulesSummary/GranulesSummary';
import { GranulesTable } from '../granulesTable/GranulesTable';

type GranulesProps = {};

type GranulesParams = {
  kapsuleId: string;
};

export const Granules: FunctionComponent<GranulesProps> = () => {
  const { kapsuleId } = useParams<GranulesParams>();
  const [granules, setGranules] = useState<Granule[]>();
  useEffect(() => {
    reloadGranules(kapsuleId);
  }, [kapsuleId]);

  const reloadGranules = async (kapsuleId: string) => {
    try {
      const granules = await getGranules(kapsuleId);
      setGranules(granules);
    } catch (e) {
      setGranules([]);
    }
  };

  return (
    <div style={{ background: 'rgba(255, 255, 255, 0.3)' }}>
      <GranulesSummary granules={granules} />
      <GranulesTable granules={granules} onGranulesDeletion={() => reloadGranules(kapsuleId)} />
    </div>
  );
};
